module.exports = "//static.hsappstatic.net/react-codemirror/static-1.5611/theme/hubspot-canvas-dark.sass"